angular.module("vgresiduos").controller("destinatorMtrListCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `acompanhamento-destinador`);
		};
	}
]);
